<div class="modal-header">
    <h3 class="modal-title" id="modal-title-id">{{LOCALIZATION.taskCompleteHeader}}</h3>
</div>
<div class="modal-body dx-form">
    <form class="form-signin" style="max-width:400px">
        <div class="row">
            <div class="col-md-12" >
                <label for="comment">{{LOCALIZATION.comments}}</label>
                <textarea [(ngModel)]='taskGroup.comment' id="comment" name="comment" class="form-control" rows="4" cols="70"></textarea>
            </div>
        </div>
    </form>
</div>
<div class="modal-footer">
	<button class="btn btn-default" type="button" (click)="close()">{{LOCALIZATION.cancel}}</button>
    <button class="btn btn-primary" type="button" (click)="completeTasks()" [disabled]="inprogress">
    	<i class="fas fa-spinner fa-spin fa-fw" [hidden]="!inprogress"></i>
    	{{LOCALIZATION.complete}}
    </button>
</div>